import React, { Component, PropTypes } from 'react';
import { withRouter } from 'react-router/es';
import { connect } from 'react-redux';
import { routeCodes } from 'constants/routes';
import { FETCH_SOURCE } from 'constants/storeStates';

export default function AuthorizationHOC(AuthComponent) {
  @connect(state => ({
    session: state.session,
  }))
  class AuthorizationComponent extends Component {
    static propTypes = {
      router: PropTypes.object,
      session: PropTypes.object,
    }

    /**
     * Push to Login page on unauth identified
     */
    pushToLogin = () => {
      const { session, router } = this.props;

      if (!session.get('authenticated') && session.get('source') === FETCH_SOURCE.ACTION) {
        router.push(routeCodes.LOGIN);
      }
    }

    componentDidMount() {
      this.pushToLogin();
    }

    componentDidUpdate() {
      this.pushToLogin();
    }

    render() {
      const { session } = this.props;

      if (!session.get('authenticated') || session.get('loading')) return null;

      return (<AuthComponent {... this.props} />);
    }
  }

  return withRouter(AuthorizationComponent);
}
